module.exports = __webpack_public_path__ + "static/media/onoiwa-mx-preview.682a2d08.png";